// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui'

import axios from 'axios'
import VueRouter from 'vue-router'

import '../theme/index.css'
import routes from './routes'
import App from './App'

import store from '@/components/store/index'
import User from '@/components/Model/User'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.config.productionTip = false

// use element UI
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    'inline': true, // 启用 inline 模式
    'button': true, // 显示右上角关闭按钮
    'navbar': true, // 显示缩略图导航
    'title': true, // 显示当前图片的标题
    'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    'rotatable': true, // 图片是否可旋转
    'scalable': true, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    'fullscreen': true, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
    'url': 'data-source' // 设置大图片的 url
  }
})

Vue.prototype.LocalUser = User;
Vue.prototype.$axios = axios;


axios.defaults.baseURL = 'http://login.ystwl.com.cn/api/';
//axios.defaults.baseURL = 'http://localhost:49285/api/';

//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.timeout = 100000;
 axios.interceptors.request.use(config => { 
  return config; 
}, 
error => { 
  return Promise.error(error); 
})


/* Browser */
function isChrome(){
  return navigator.userAgent.indexOf("Chrome")!=-1;
}
function isEdge(){
  return navigator.userAgent.indexOf("Edge")!=-1;
}

/* method */
Vue.prototype.downloadAttachment=function(attachmentID)
{
    var attachmentURL = String.format('{0}temp/{1}', hostURL, attachmentID);
    window.location = attachmentURL;
}

/*显示一个自动隐藏的消息*/
Vue.prototype.flyMsg = function (message,callbackFn) {
  this.$message({
      message:message,
  });
}
/*显示成功消息*/
Vue.prototype.showSuccess =function (message,callbackFn) {
  this.$message({
      message:message,
      type: 'success',
      showClose: true,
  });
}
/*显示信息*/
Vue.prototype.showInfo =function (message,callbackFn) {
  this.$message({
      message:message,
      type: 'showInfo',
      showClose: true,
  });
}
/*显示警告*/
Vue.prototype.showWarning =function (message,callbackFn) {
  this.$message({
      message:message,
      type: 'warning',
      showClose: true,
  });
}
/*显示错误*/
Vue.prototype.showError =function (message,callbackFn) {
  this.$message({
      message:message,
      type: 'error',
      showClose: true,
  });
}
/*提示信息*/
Vue.prototype.alert=function (message, title, callbackFn, buttonText) {
  var me = this;
  this.$alert(message, title, {
      confirmButtonText: buttonText||'OK',
      callback: action => {
          if( callbackFn != null)
          {
              callbackFn.call(me);
          }
      }
  });
}
/*确认信息*/
Vue.prototype.confirm= function (message, title, callbackFn, buttonText) {
  var me = this;
  this.$confirm(message, title || '提示', {
      confirmButtonText: 'OK',
      cancelButtonText:'Cancel',
      type: 'warning'
  }).then(() => {
      if( callbackFn != null)
      {
          callbackFn.call(me, true);
      }
  }).catch(() => {
      if( callbackFn != null)
      {
        // callbackFn.call(me, false, value);
      }
  });
}
/*输入信息*/
Vue.prototype.prompt= function (message, title, callbackFn, buttonText, defaultText) {
  var me = this;
  this.$prompt(message, title || PM.getRes('prompt'), {
      confirmButtonText:'OK',
      cancelButtonText:  'Cancel',
  }).then(({ value }) => {
      if( callbackFn != null)
      {
          callbackFn.call(me, true, value);
      }
  }).catch(() => {
      if( callbackFn != null)
      {
          callbackFn.call(me, true, value);
      }
  });
}
Vue.prototype.showLoadMask=function(loadingText){
  var me = this;
  window.localStorage.setItem("IsCanBack",false);
}
Vue.prototype.hideLoadMask=function(){
  var me = this;
  window.localStorage.setItem("IsCanBack",true);
}
Vue.prototype.ShowPreloader=function() {
  Vue.prototype.PreLoader = this.$loading({
      lock: true,
      text: this.getRes("WorkflowOperation.Processing"),
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
  });
}
Vue.prototype.HidePreloader=function() {
  Vue.prototype.PreLoader.close();
}
Vue.prototype.defaultFailureFn =function (exceptionMsg,callbackFn) {
  var me = this;
  var localUser = me.LocalUser;
  me.hideLoadMask();
  console.log('Exception Level:'+exceptionMsg.Level);
  switch (exceptionMsg.Level) {
      case 1:
          {
              /*匿名访问不被允许*/
              me.alert('匿名访问不被允许','通知',function(){
//                    me.redirectTo("login", false);
              });
              break;
          }
      case 2:
          {
              /*客户端令牌失效,需要重新登录*/
              me.flyMsg('客户端令牌失效,需要重新登录');
              window.localStorage.setItem('Authencated', false);
              me.LocalUser.logout();

              /*刷新页面*/
              document.location.href = 'index.html';
              break;
          }
      case 3:
          {
              /*用户帐户被锁定*/
              me.alert('用户帐户被锁定','通知',callbackFn);
              break;
          }
      case 4:
          {
              /*服务被锁定*/
              me.alert('服务被锁定','通知',callbackFn);
              break;
          }
      case 5:
          {
              /*没有访问权限*/
              me.alert('没有访问权限','通知',callbackFn);
              break;
          }
      case 6:
          {
              /*不正确的参数*/
              me.alert('不正确的参数','通知',callbackFn);
              break;
          }
      case 7:
          {
              /*跨设备登录*/
              me.alert('跨设备登录','通知',callbackFn);
              break;
          }
      case 20:
          {
              /*许可错误*/
              me.alert('许可错误','通知',callbackFn);
              break;
          }
      case 21:
          {
              /*待定义错误*/
              me.alert('待定义错误','通知',callbackFn);
              break;
          }
      case 22:
          {
              /*待定义错误*/
              me.alert('待定义错误','通知',callbackFn);
              break;
          }
      case 23:
          {
              /*待定义错误*/
              me.alert('待定义错误','通知',callbackFn);
              break;
          }
      case 24:
          {
              /*待定义错误*/
              me.alert('待定义错误','通知',callbackFn);
              break;
          }
      case 99:
          {
              /*通讯失败*/
              me.flyMsg('通讯失败',callbackFn);
              break;
          }
      case 100:
          {
              /*运行期发生异常*/
              var message = '运行期发生异常' + exceptionMsg.Summary;
              me.alert(message,'通知',callbackFn);
              break;
          }
  }
}

Vue.prototype.setCookie = function (cookieName, cookieValue, exDateOffset) {
  var exdate=new Date()
  exdate.setDate(exdate.getDate() + exDateOffset)
  document.cookie = cookieName + "=" +escape(cookieValue) + ((exDateOffset == null) ? "" : ";expires=" + exdate.toGMTString());
},
Vue.prototype.getCookie = function (cookieName) {
  if (document.cookie.length > 0){
      var c_start = document.cookie.indexOf(cookieName + "=");
      if (c_start != -1){ 
          var c_start = c_start + cookieName.length + 1;
          var c_end = document.cookie.indexOf(";", c_start)
          if (c_end == -1) c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end))
          } 
  }
  return ""
}

const router = new VueRouter({
  //mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to.path);
  if (to.path == '/Login') {
    sessionStorage.removeItem('user');
    next()
  }
  else{
    let user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path != '/Login'&& to.path != '/testapi') {
      next({ path: '/Login' })
    } else {
      next()
    }
  }
  
})



Date.prototype.Format = function (fmt) { //author: meizz 
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "H+": this.getHours(), //小时 
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}


Vue.prototype.handleSelectLeftMenu = function (item) {
        if(item.Name != null && item.Name != "")
            this.$router.push(item.Name ); 
}


Date.prototype.Format = function (fmt) {
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "H+": this.getHours(), //小时 --------*********仅支持24小时制**************
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

Date.prototype.addDays = function (value) {
  var date = this.getDate();
  this.setDate(date + value);
  return this;
};

//将指定的年份数加到此实例的值上 
Date.prototype.addYears = function (value) {
  var year = this.getFullYear();
  this.setFullYear(year + value);
  return this;
};

//将指定的小时数加到此实例的值上 
Date.prototype.addHours = function (value) {
  var hour = this.getHours();
  this.setHours(hour + value);
  return this;
};

//将指定的星期数加到此实例的值上 
Date.prototype.addWeeks = function (value) {
  return this.addDays(value * 7);
};
//将指定的月份数加到此实例的值上 
Date.prototype.addMonths = function (value) {
  var month = this.getMonth();
  this.setMonth(month + value);
  return this;
};

Vue.prototype.invokeGetService = function (method, args, successFn,failFn, exceptionFn) {
  this.$axios
    .get(method,args)
    .then((response) => {
      if (response.data.IsSuccess == true) 
      {
        if(successFn!=null)
        {
          successFn.call(this,response);
        }      
      }
      else
      {
        var str= '';
        response.data.Messages.forEach(element=>{
          str += element.Message;
        })
        ElementUI.MessageBox({
          title: '提示',
          message: str
        });

        if(failFn!=null)
        {
          failFn.call(this,response);
        }  
      }
    })
    .catch(function (error) {
          console.log(error);
          ElementUI.MessageBox({
            title: '异常',
            message: error
      });

      if(exceptionFn!=null)
        {
          exceptionFn.call(this,response);
        }  
    }); 
}

Vue.prototype.invokePostService = function (method, args, successFn,failFn, exceptionFn) {
  this.$axios
    .post(method,args)
    .then((response) => {
      if (response.data.IsSuccess == true) 
      {
        if(successFn!=null)
        {
          successFn.call(this,response);
        }      
      }
      else
      {
        var str= '';
        response.data.Messages.forEach(element=>{
          str += element.Message;
        })
        ElementUI.MessageBox({
          title: '提示',
          message: str
        });

        if(failFn!=null)
        {
          failFn.call(this,response);
        }  
      }
    })
    .catch(function (error) {
          console.log(error);
          ElementUI.MessageBox({
            title: '异常',
            message: error
      });

      if(exceptionFn!=null)
        {
          exceptionFn.call(this,response);
        }  
    }); 
}


new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')
/* eslint-disable no-new */
/* new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
}) */



// WEBPACK FOOTER //
// ./src/main.js